import { clsx } from 'clsx';
import type { ReactNode } from 'react';

type Props = {
  tone?: 'info' | 'warn' | 'success' | 'danger';
  title?: string;
  children: ReactNode;
};

const toneClass: Record<NonNullable<Props['tone']>, string> = {
  info:    'border-accent-200 border-l-accent-500 bg-accent-50   text-ink-800',
  warn:    'border-warn-200   border-l-warn-500   bg-warn-100/60 text-ink-800',
  success: 'border-econ-200   border-l-econ-500   bg-econ-50     text-ink-800',
  danger:  'border-credit-200 border-l-credit-500 bg-credit-100/40 text-ink-800',
};

export function Callout({ tone = 'info', title, children }: Props) {
  return (
    <div className={clsx('rounded-xl border border-l-4 px-4 py-3.5 text-sm leading-relaxed', toneClass[tone])}>
      {title && <div className="font-semibold text-ink-900 mb-1">{title}</div>}
      <div>{children}</div>
    </div>
  );
}
